<ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
<ng-template #contentTemplate>
  <div class="d-flex flex-column h-100">
    <div class="offcanvas-header d-flex justify-content-between py-0">
      <h4 class="offcanvas-title mt-0">Node : {{ selectedNode.vmName }}</h4>
      <div class="default-btn job-status" triggers="hover" ngbTooltip="Type - {{selectedNode.nodeType}}, State - {{ selectedNode.state }}, Schedular State - {{ selectedNode.schedulerState }}">
        {{ selectedNode.nodeType }} - {{ selectedNode.state }} - {{ selectedNode.schedulerState }}
      </div>
      <button type="button" class="actionBtn" (click)="close()" matTooltip="Close">
        <mat-icon style="color: red;">close</mat-icon>
      </button>
    </div>
    <div class="offcanvas-body flex-grow-1 py-0 pt-1 d-flex flex-column">
      <div class="options">
        <p (click)="openDetails()" [ngClass]="{ active: active === 1 }" title="Details of {{ selectedNode.vmName }}">
          Node Details
        </p>
        <ng-container *ngIf="node?.state != 'Unassigned'">
          <div class="btn-group" ngbDropdown container="body" role="group"
            aria-label="Button group with nested dropdown">
            <!-- <i title="Node actions"
              class="btn dropdown-toggle-split bi bi-three-dots p-0 border-0 bg-transparent synchpc-primary"
              ngbDropdownToggle></i> -->
            <button class="default-btn" ngbDropdownToggle>Actions</button>
            <div class="dropdown-menu" ngbDropdownMenu>
              <button ngbDropdownItem *ngFor="let action of selectedNode.actionsAvl"
                (click)="emitNodeAction(action)" [title]="action.title"
                [class.disabled]="action.disabled"><i class="bi" [ngClass]="action.icon"
                  style="color: var(--s-primary-color);"></i> &nbsp;<span class="fs-6 text-dark"
                  style="font-size: 13px!important;">{{ action.name }}</span></button>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="childs flex-grow-1">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #noContent>
  <p class="pt-5 text-center">Something went wrong!</p>
</ng-template>